import axios from 'axios'
import Utils from '../../../common/utils';

export default {
  search: function (request) {
    return axios.get('/api/poll/search', { params: request })
  },
  exportFile: function(uid) {
    return Utils.downloadFile('/api/poll/exportFile?uid='+uid, "TestResult.docx")
  },
  save: function (data) {
    if(data.id) {
      return axios.post('/api/poll/updateTmpPatient', data);
    } else {
      return axios.post('/api/poll/createTmpPatient', data);
    }
  },
  delete: function(id) {
    return axios.delete('/api/poll/deleteTmpPatient?id='+id)
  },
  changeStatus: function (data) {
    return axios.post('/api/poll/updateTmpPatientStatus', data);
  },
  find: function(id) {
    return axios.get('/api/poll/findTmpPatient?id=' + id);
  },
  getPoll: function() {
    return axios.get('/api/poll/getPoll');
  },
  updatePatientMedOrgAttach: function(id) {
    return axios.get(`/api/import/UpdatePatientMedOrgAttach/${id}`, {});
  },
  getMedOrgs: function() {
    return axios.get('/api/poll/MedOrgs');
  }
}
